"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var FirstIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { fill: "currentColor", transform: "rotate(180 9.5 10)" },
        React.createElement("path", { d: "M5.46062427,12.0054419 C3.38746804,14.2024481 1.68179901,16 1.67025011,16 C1.65870122,16 1.28292732,15.6113347 0.835196834,15.1363008 L0.0211424482,14.2726033 L2.97030854,11.1472299 L5.91947629,8.02185766 L2.95973814,4.88528264 L0,1.74870779 L0.824880547,0.874353982 C1.27856452,0.393459222 1.65907578,0 1.67046297,0 C1.69075068,0 9.22999954,7.97848437 9.22999954,7.99995497 C9.22999954,8.00596608 7.53378051,9.80843561 5.46062427,12.0054419 Z" }),
        React.createElement("rect", { width: "2", height: "16", x: "12" })))); };
exports.FirstIcon = FirstIcon;
